import { AxiosInstance } from 'axios'

export default (client: AxiosInstance): boolean => {
    const getParams = getGetParams()

    if (!getParams.has('api_key') || !getParams.has('compenda_user_id')) { 
        return false
    }

    const apiKey = String(getParams.get('api_key'))
    const compendaUserId = Number(getParams.get('compenda_user_id'))

    setAuthHeaders(client, apiKey, compendaUserId)

    return true
}

const getGetParams = (): Map<string, string> => {
    const getParams: Map<string, string> = new Map<string, string>()
    location.search
        .substr(1)
        .split('&')
        .forEach((item) => {
            const [key, value] = item.split('=')
            getParams.set(key, value)
        })
    return getParams
}

const setAuthHeaders = (client: AxiosInstance, apiKey: string, compendaUserId: number) => {
    client.defaults.headers.common.Authorization = 'Bearer ' + apiKey
    client.defaults.headers.common.CompendaUserId = compendaUserId
}
